import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "system_log_product_code_field",
      "id": "system_log_product_code_field"
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "product_sku"
    }
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('a-select-option', {
    attrs: {
      "value": "user_name"
    }
  }, [_vm._v(_vm._s(_vm.t('操作人')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "data-permission": "system_log_product_code_value",
      "id": "system_log_product_code_value",
      "allowClear": "",
      "maxLength": 100
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('日志时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "data-permission": "system_log_product_datetime",
      "id": "system_log_product_datetime",
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-permission": "system_log_product_search",
      "id": "system_log_product_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "system_log_product_reset",
      "id": "system_log_product_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "name": "systemLogProductList",
      "columns": _vm.columns,
      "fixed-header": "",
      "data-source": _vm.dataList,
      "row-key": "_rowKey",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "remark",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.remark
          }
        })], 1);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "name": "systemLogProductList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };